import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import AssignEmployeesToPolicyModal from 'modules/payroll_bundle/components/settings/AssignEmployeesToPolicyModal'
import EmployeesTable from 'modules/payroll_bundle/components/settings/EmployeesTable'
import { useGetPolicyActiveEmployees } from 'modules/payroll_bundle/hooks/useGetPolicyActiveEmployees'

interface Props {
  contractVersions: ContractVersions
}

const EmployeesPage = observer(({ contractVersions }: Props) => {
  const [showAssignModal, setShowAssignModal] = useState(false)

  function openModal() {
    setShowAssignModal(true)
  }

  function closeModal() {
    setShowAssignModal(false)
  }

  const params = useParams()
  const { fetching, policyActiveEmployees, policy, employees, refetch } =
    useGetPolicyActiveEmployees(params.policyId ?? '', contractVersions)

  function handleAssignEmployeesToPolicyCompleted() {
    closeModal()
    refetch()
  }

  return (
    <>
      <Section
        illustration="user-male-female"
        title={i18n.t('app_store_v2.apps.payroll_bundle.settings.payroll_policy.employees.title')}
        description={i18n.t(
          'app_store_v2.apps.payroll_bundle.settings.payroll_policy.employees.description_self_onboarding'
        )}
        action={{
          label: i18n.t(
            'app_store_v2.apps.payroll_bundle.settings.payroll_policy.assign_to_policy_action.label'
          ),
          onClick: openModal,
        }}
      >
        <EmployeesTable employees={policyActiveEmployees} loading={fetching} />
      </Section>

      {showAssignModal && policy !== undefined && (
        <AssignEmployeesToPolicyModal
          onClose={closeModal}
          employees={employees.models}
          policyActiveEmployeeIds={policyActiveEmployees.map((employee) => employee.id)}
          policy={policy}
          onCompleted={handleAssignEmployeesToPolicyCompleted}
        />
      )}
    </>
  )
})

export default EmployeesPage
